import React from 'react';
import { Button } from './ui/button';
import { BOT_NOT_ADMITTED_COPY, BotNotAdmittedReason } from '../constants/botAdmission';
import { notAdmittedMessage } from '../utils/botNotAdmitted';

interface BotNotAdmittedNoticeProps {
  reason: BotNotAdmittedReason;
  /** Clears the notice; starting another session clears it too. */
  onDismiss: () => void;
}

/**
 * "Bot not let in" and why (owner decision 2026-10-03): the meeting host never
 * let the bot in, so there was no call and no summary. The same label, reasons
 * and Dismiss as the desktop apps' status card (macOS SessionStatusView): an
 * amber pill and Dismiss, then the reason. It sits in the session status card
 * (ConversationPage).
 */
const BotNotAdmittedNotice: React.FC<BotNotAdmittedNoticeProps> = ({ reason, onDismiss }) => (
  <div role="status" className="min-w-0 space-y-1">
    <div className="flex items-center justify-between gap-2">
      <span
        className="inline-flex shrink-0 items-center gap-1.5 rounded-full px-2 py-[3px] text-xs font-semibold text-warning"
        style={{ backgroundColor: 'color-mix(in srgb, var(--warning) 12%, transparent)' }}
      >
        <span className="h-2 w-2 shrink-0 rounded-full bg-warning" aria-hidden="true" />
        {BOT_NOT_ADMITTED_COPY.title}
      </span>
      <Button variant="tertiary" size="sm" onClick={onDismiss} className="shrink-0 text-xs">
        {BOT_NOT_ADMITTED_COPY.dismiss}
      </Button>
    </div>
    <p className="text-[11px] text-ink-secondary">{notAdmittedMessage(reason)}</p>
  </div>
);

export default BotNotAdmittedNotice;
